// Static shared values. Per-portal dynamic values live in portalConfig.js. Backend/Keycloak URLs pick prod vs test from IS_PRODUCTION (URL-derived, see env.js).
// PROJECT_FILE_DATE and PROJECT_FINISHED are read from public/config.js's window.conf so ops can change them per deployment without rebuilding.

import { IS_PRODUCTION, EFFECTIVE_HOSTNAME, CLIENT_ID } from './env'

export const API = IS_PRODUCTION
    ? 'https://backend.bautvplus.de/graphql/'
    : 'https://backend.test.bautvplus.de/graphql/'

export const KEYCLOAK = {
    REALM: IS_PRODUCTION
        ? 'netco'
        : 'netco-test',
    SERVER: IS_PRODUCTION
        ? 'https://login.bautvplus.de/'
        : 'https://login.test.bautvplus.de/',
    CLIENT_ID
}

export const APP = {
    REDIRECT: IS_PRODUCTION
        ? 'https://projekte.bautvplus.de/app'
        : 'https://projekte.test.bautvplus.de/app',
    STORE: {
        GOOGLE: 'https://play.google.com/store/apps/details?id=de.netco.bautv',
        APPLE: 'https://apps.apple.com/de/app/bautv/id6740990801'
    }
}

export const AI_PARAMETERS = {
    AI_REPORT_ENABLED: 7,           // gates Dashboard "Object detection" tab
    ACCESS_MONITORING_ENABLED: 26,  // gates Access Monitoring
    PROJECT_REPORT_ENABLED: 27,     // gates Report
    CHATBOT_ENABLED: 28,            // gates Chatbot
    DASHBOARD_ENABLED: 29           // unused
}

export const STATS = {
    HEADERS: { 'X-ET-Token': '0292d8eed7d238cb3cf9de9d337a1a29fde53bd2f1e0e111cee5f818749d5fec737948dd48052b119dba30b1023e5097' },
    SERVER: 'https://ws.etracker.com/api/v7/'
}

export const WEATHER_CATEGORY = 'Wetter_vmnj94o85ztm49hg9v4' // db row in archive_picture_detail.kategorie

const runtimeLayout = (typeof window !== 'undefined' && window.conf?.LAYOUT) || {} // DEFAULT_LANG / PROJECT_FILE_DATE / PROJECT_FINISHED come from public/config.js so ops can change them per deployment without rebuilding

export const LAYOUT = {
    DEFAULT_LANG: runtimeLayout.DEFAULT_LANG ?? 'de',
    INVERTED_COLORS: true,
    LOGO_FRAME: false,
    PROJECT_FILE_DATE: runtimeLayout.PROJECT_FILE_DATE ?? '',
    PROJECT_FINISHED: runtimeLayout.PROJECT_FINISHED ?? false,
    WRAP_LIMIT: 10, // cameras per row before layout shifts
    PREVENT_ZOOM: false
}

export const BASEURL = `https://${EFFECTIVE_HOSTNAME}/` // in production BASEURL equals window.location.origin; in dev it points at the portal EFFECTIVE_HOSTNAME resolves to (for camera images)

// ROUTES static skeleton — portalConfig.js merges the dynamic `protected` flag in and re-exports the complete ROUTES object
export const ROUTES_STATIC = {
    HOME:      { id: 0, path: '/',          role: 'homePage',      disabled: false },
    LIVE:      { id: 1, path: '/live',      role: 'livePage',      disabled: false },
    TIMELAPSE: { id: 2, path: '/timelapse', role: 'timelapsePage', disabled: false },
    ARCHIVE:   { id: 3, path: '/archive',   role: 'archivePage',   disabled: false },
    MYSITE:    { id: 4, path: '/mysite',    role: 'sitePage',      disabled: false },
    ACCESS:    { id: 5, path: '/access',    role: 'accessPage',    disabled: false }
}

export { DEBUG, CLIENT_ID, IS_DEV, IS_PRODUCTION } from './env'